"use strict";

// ##############
// TRUTH DETECTOR
// ##############

// Determines what counts as true or false

module.exports = function coerceBoolean(value) {

	if (! value) return false;
	else if (value === 0) return false;
	else if (value === '0') return false;
	else if (String(value).toLowerCase() === 'n') return false;
	else if (String(value).toLowerCase() === 'false') return false;
	else if (String(value).toLowerCase() === 'null') return false;

	return true;
}



